import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

export function EmptyState({
  icon = 'search',
  title,
  description,
  action,
  size = 'default',
}: {
  /** `null` drops the icon entirely — a row-level empty ("No songs queued.") is one line inside a
   * list, and an icon there is chrome the operator has to read past on every idle slot. */
  icon?: IconName | null;
  title: string;
  description?: string;
  action?: ReactNode;
  /** MVP-11 #29: `compact` replaces bespoke empty-state fragments that don't have room for the
   * default's --space-16 padding — e.g. `QueuePanel`'s `.rotation-slot__empty` and `LyricStage`'s
   * `.lyric-stage__missing`. */
  size?: 'default' | 'compact';
}) {
  return (
    <div className={`state-panel${size === 'compact' ? ' state-panel--compact' : ''}`} data-testid="empty-state">
      {icon !== null && (
        <div className="state-panel__icon">
          <Icon name={icon} size={size === 'compact' ? 20 : 32} />
        </div>
      )}
      <p className="state-panel__title text-subtitle">{title}</p>
      {description && <p className="state-panel__description text-body">{description}</p>}
      {action}
    </div>
  );
}
